<template>
  <v-card outlined class="mx-auto container-profile">
    <!--    <v-img-->
    <!--      class="white&#45;&#45;text align-end"-->
    <!--      height="200px"-->
    <!--      src="https://cdn.vuetifyjs.com/images/cards/docks.jpg"-->
    <!--    >-->
    <!--    </v-img>-->
    <slot name="header"></slot>
    <slot name="title"></slot>
    <slot name="subtitle"></slot>
    <slot name="body"></slot>
    <slot name="footer"></slot>
<!--    <v-card-text class="text&#45;&#45;primary">-->
<!--      <div>Whitehaven Beach</div>-->

<!--      <div>Whitsunday Island, Whitsunday Islands</div>-->
<!--    </v-card-text>-->

<!--    <v-card-actions>-->
<!--      <v-btn-->
<!--        color="orange"-->
<!--        text-->
<!--      >-->
<!--        Share-->
<!--      </v-btn>-->

<!--      <v-btn-->
<!--        color="orange"-->
<!--        text-->
<!--      >-->
<!--        Explore-->
<!--      </v-btn>-->
<!--    </v-card-actions>-->
  </v-card>
</template>

<script>
export default {
  name: "UserCard"
}
</script>

<style scoped>

</style>
